import React, { useState } from "react";
import { getBoxTypesInformation } from "../firebase/fireFuncs";
import useModal from "../hooks/useModal";
import SmallItemHolder from "../misc/elements/SmallItemHolder";
import { objectToArray } from "../misc/helperfuncs";
import PickRelatedBoxTypesModal from "../modals/PickRelatedBoxTypesModal";
import TypeDescriptionHolder from "./TypeDescriptionHolder";
import { toast } from "react-toastify";

const PickRelatedTypes = ({
  selected,
  descriptions,
  onSelected,
  onDescription,
}) => {
  const [inp, setInp] = useState("");
  const modal = useModal({
    password: "openList",
    modalContent: (
      <PickRelatedBoxTypesModal
        selectedBoxTypes={selected}
        onSelected={onSelected}
      />
    ),
  });

  function onInformation(info) {
    const typeNames = objectToArray(info.typeNames, "name", "used");
    if (typeNames.map((tn) => tn.name).includes(inp)) {
      onSelected(inp);
      setInp("");
      return;
    } else {
      setInp("");
      toast("Type not found");
    }
  }

  function addType() {
    if (inp.length > 3) {
      getBoxTypesInformation(onInformation);
    }
  }

  function onEnter(e) {
    if (e.key === "Enter") {
      addType();
    }
  }

  return (
    <div className="divColumn" style={{ marginTop: "5px" }}>
      <div className="divColumn" style={{ minHeight: "24px", width: "100%" }}>
        {selected.map((boxType) => (
          <TypeDescriptionHolder
            onRemoveType={onSelected}
            type={boxType}
            onDescription={onDescription}
            key={boxType}
          />
        ))}
      </div>
      <div className="divRow">
        <input
          onKeyDown={onEnter}
          maxLength={20}
          style={{
            textAlign: "center",
            backgroundColor: "#6f6f6f",
            color: "white",
            fontSize: "20px",
          }}
          value={inp}
          onChange={(e) => setInp(e.target.value.replace(/[^a-z\s]/gi, ""))}
        />
        <button
          onClick={addType}
          className="textBold"
          style={{
            fontSize: "19px",
            backgroundColor: "#2f2f2f",
            color: "white",
          }}
        >
          Add
        </button>
        <button
          onClick={() => modal.open("openList")}
          className="textBold"
          style={{
            fontSize: "19px",
            backgroundColor: "#2f2f2f",
            color: "white",
          }}
        >
          List
        </button>
      </div>
      {modal.element}
    </div>
  );
};

const RelatedHoler = ({ name }) => {
  return (
    <div
      className="divRow"
      style={{
        padding: "3px",
        borderRadius: ".5rem/.5rem",
        border: "2px solid grey",
      }}
    >
      <img className="icon20" src="/icons/icon_box.png" />
      <div className="textBold">{name}</div>
    </div>
  );
};

export default PickRelatedTypes;
